export const useFormatDate = (date: string): string => {
	if (!date) return "";
	const { $dayjs } = useNuxtApp();

	return $dayjs(date).format("DD.MM.YYYY");
};
